export default class ListingTemplates {
  render(listing_type, data) {
    return this[listing_type.replaceAll('-', '_')](data);
  }

  getFeaturedImageUrl(image, type = null) {
    if (image == "" || image == false) {
      if(type == 'sports') {
        return '/wp-content/themes/tahoesouth/assets/images/listing-default/sports.jpg';
      } else {
        return '/wp-content/themes/tahoesouth/assets/images/listing-default/default.jpg';
      }
    }

    return image;
  }

  // For special offers, use featured image if it exists, then associated post featured image, then fallback to default.
  getSpecialOfferFeaturedImageUrl(image, fallbackImage) {
    if (image == "" || image == false) {
      if (fallbackImage == "" || fallbackImage == false) {
        return '/wp-content/themes/tahoesouth/assets/images/listing-default/default.jpg';
      }

      return fallbackImage;
    }

    return image;
  }

  getType(type) {
    if (type && type != "") {
      return `<p class="stakeholder-listing-card__type">` + type + `</p>`;
    }

    return "";
  }

  exclusiveTag(specialOffers, pageUrl) {
    let exclusiveTag = '';
    let offerLink = '';

    if (specialOffers != false) {
      let hasExclusiveOffer = false;

      specialOffers.forEach(specialOffer => {
        if (specialOffer.is_exclusive) {
          hasExclusiveOffer = true;
        }
      });

      if(specialOffers.length == 1) {
        offerLink = specialOffers[0].offer_url;
      }

      exclusiveTag = `
        <a href="${pageUrl}#special-offers" data-direct-offer-url="${offerLink}" class="exclusive-offer-tag stakeholder-listing-card__exclusive-tag ${ hasExclusiveOffer ? '' : '--special'}">
            <p class="exclusive-offer-tag__text">${ hasExclusiveOffer ? 'Exclusive Offer' : 'Special Offer'}</p>
        </a>
      `;
    }

    return exclusiveTag;
  }

  getWebsiteUrl(data, theme = '--blue') {
    let icon_theme = '--light-default';

    if(theme == '--white') {
      icon_theme = '--dark-default';
    }

    if(data.website_url) {
      return `<a class="stakeholder-listing-card__button button --primary --external gtm-referral-link" href="${data.website_url}" target="_blank" data-category="${data.primary_poi_cat}" data-name="${data.title.rendered}" data-type="${data.type}">Website</a>`;
    }

    return ``;
  }

  wedding(data) {
    let term = 'wedding-type';
    return this.advanced_card(data, '', term);
  }

  post(data) {
    return `
      <div class="stakeholder-listing-card">
          <a href="` + data.link + `" class="stakeholder-listing-card__link">
              <picture class="stakeholder-listing-card__image-container">
                  <img class="stakeholder-listing-card__image" src="` + this.getFeaturedImageUrl(data.featured_image_url_sizes['medium_large']) + `" alt="">
              </picture>
              <p class="stakeholder-listing-card__title">` + data.title.rendered + `</p>
              ` + this.getType(data.primary_terms['category']) + `
          </a>
      </div>
    `;
  }

  author(data) {
    return `
      <div class="stakeholder-listing-card">
          <a href="` + data.link + `" class="stakeholder-listing-card__link">
              <picture class="stakeholder-listing-card__image-container">
                  <img class="stakeholder-listing-card__image" src="` + this.getFeaturedImageUrl(data.featured_image_url_sizes['medium_large']) + `" alt="">
              </picture>
              <p class="stakeholder-listing-card__title">` + data.title.rendered + `</p>
          </a>
      </div>
    `;
  }

  explore(data) {
    return `
      <div class="stakeholder-listing-card">
          <a href="` + data.link + `" class="stakeholder-listing-card__link">
              <picture class="stakeholder-listing-card__image-container">
                  <img class="stakeholder-listing-card__image" src="` + this.getFeaturedImageUrl(data.featured_image_url_sizes['medium_large']) + `" alt="">
              </picture>
              <p class="stakeholder-listing-card__title">` + data.title.rendered + `</p>
          </a>
      </div>
    `;
  }

  meeting(data) {
    return `
      <div class="stakeholder-listing-card">
          <a href="` + data.link + `" class="stakeholder-listing-card__link">
              <div class="stakeholder-listing-card__top-container">
                <picture class="stakeholder-listing-card__image-container">
                    <img class="stakeholder-listing-card__image" src="` + this.getFeaturedImageUrl(data.featured_image_url_sizes['medium_large']) + `" alt="">
                </picture>
              </div>
              <p class="stakeholder-listing-card__title">` + data.title.rendered + `</p>
          </a>
      </div>
    `;
  }

  advanced_card(data, exclusiveTag = '', term = '') {
    return `
      <div class="stakeholder-listing-card --advanced-card">
        <a href="${data.link}" class="stakeholder-listing-card__link">
          <div class="stakeholder-listing-card__top-container">
            <picture class="stakeholder-listing-card__image-container">
                <img class="stakeholder-listing-card__image" src="${this.getFeaturedImageUrl(data.featured_image_url_sizes['medium_large'])}" alt="">
            </picture>
            ${exclusiveTag}
          </div>
        </a>
        <div class="stakeholder-listing-card__bottom-container">
          <p class="stakeholder-listing-card__title">${data.title.rendered}</p>
          ${this.getType(data.primary_terms[term])}
          <div class="stakeholder-listing-card__buttons">
            ${this.getWebsiteUrl(data)}
            <a class="stakeholder-listing-card__button button --secondary" href="${data.link}">Details</a>
          </div>
        </div>
      </div>
    `;
  }

  thing_to_do(data) {
    let exclusiveTag = this.exclusiveTag(data.special_offers, data.link);
    let term = 'things-to-do';
    return this.advanced_card(data, exclusiveTag, term);
  }

  eat(data) {
    let exclusiveTag = this.exclusiveTag(data.special_offers, data.link);
    let term = 'place-to-eat';
    return this.advanced_card(data, exclusiveTag, term);
  }

  press_release(data) {
    return `
      <div class="stakeholder-listing-card">
          <a href="` + data.link + `" class="stakeholder-listing-card__link">
              <picture class="stakeholder-listing-card__image-container">
                  <img class="stakeholder-listing-card__image" src="` + this.getFeaturedImageUrl(data.featured_image_url_sizes['medium_large']) + `" alt="">
              </picture>
              <p class="stakeholder-listing-card__title">` + data.title.rendered + `</p>
          </a>
      </div>
    `;
  }

  sport(data) {
    let term = 'sport-type';
    return this.advanced_card(data, '', term);
  }

  stay(data) {
    let exclusiveTag = this.exclusiveTag(data.special_offers, data.link);
    let term = 'place';
    return this.advanced_card(data, exclusiveTag, term);
  }

  special_offer_cro(data) {
    const associatedPost = data.associated_post;

    if (associatedPost != false && associatedPost.post_status == "publish") {
      let exclusiveTag = `
        <div class="exclusive-offer-tag special-offer-listing-card__exclusive-tag">
            <p class="exclusive-offer-tag__text">Exclusive Offer</p>
        </div>
      `
      if (data.meta['offer_exclusive'] !== true) {
        exclusiveTag = '';
      }

      return `
        <div class="special-offer-listing-card --cro">
            <a href="${data.meta.offer_link.url}" target="_blank" class="special-offer-listing-card__link">
                <div class="special-offer-listing-card__top-container">
                  <picture class="special-offer-listing-card__image-container">
                    <img class="special-offer-listing-card__image" src="${this.getSpecialOfferFeaturedImageUrl(data.featured_image_url_sizes['medium_large'], associatedPost.featured_image_url)}" alt="${associatedPost.post_title}">
                  </picture>
                  ${exclusiveTag}
                </div>
                <p class="special-offer-listing-card__date">Expires ${data.meta["offer_expiration-date"]}</p>
                <p class="special-offer-listing-card__title">${associatedPost.post_title}</p>
                <p class="special-offer-listing-card__description">${data.meta.offer_title}</p>
                <p class="special-offer-listing-card__cta button --primary --external">Redeem Offer</p>
            </a>
        </div>
      `;
    } else { // Display the offer, but note it is broken.
      return `
        <div class="special-offer-listing-card --cro">
            <picture class="special-offer-listing-card__image-container">
                <img class="special-offer-listing-card__image" src="${this.getFeaturedImageUrl(data.featured_image_url_sizes['medium_large'])}" alt="${data.title.rendered}">
            </picture>
            <p class="special-offer-listing-card__date">${data.meta["offer_expiration-date"]}</p>
            <p class="special-offer-listing-card__title">${data.title.rendered}</p>
            <p class="special-offer-listing-card__description">Offer not associated with a valid point of interest.</p>
            <p class="special-offer-listing-card__cta button --primary --external">Redeem Offer</p>
        </div>
      `;
    }
  }

  special_offer(data) {
    const associatedPost = data.associated_post;

    if (associatedPost != false && associatedPost.post_status == "publish") {
      let exclusiveTag = `
        <div class="exclusive-offer-tag special-offer-listing-card__exclusive-tag">
            <p class="exclusive-offer-tag__text">Exclusive Offer</p>
        </div>
      `
      if (data.meta['offer_exclusive'] !== true) {
        exclusiveTag = '';
      }

      return `
        <div class="special-offer-listing-card">
            <a href="${data.meta.offer_link.url}" target="_blank" class="special-offer-listing-card__link">
                <div class="special-offer-listing-card__top-container">
                  <picture class="special-offer-listing-card__image-container">
                    <img class="special-offer-listing-card__image" src="${this.getSpecialOfferFeaturedImageUrl(data.featured_image_url_sizes['medium_large'], associatedPost.featured_image_url)}" alt="${associatedPost.post_title}">
                  </picture>
                  ${exclusiveTag}
                </div>
                <p class="special-offer-listing-card__title">${associatedPost.post_title}</p>
                <p class="special-offer-listing-card__description">${data.meta.offer_title}</p>
                <p class="special-offer-listing-card__date">Expires ${data.meta["offer_expiration-date"]}</p>
            </a>
        </div>
      `;
    } else { // Display the offer, but note it is broken.
      return `
        <div class="special-offer-listing-card">
            <picture class="special-offer-listing-card__image-container">
                <img class="special-offer-listing-card__image" src="${this.getFeaturedImageUrl(data.featured_image_url_sizes['medium_large'])}" alt="${data.title.rendered}">
            </picture>
            <p class="special-offer-listing-card__title">${data.title.rendered}</p>
            <p class="special-offer-listing-card__description">Offer not associated with a valid point of interest.</p>
            <p class="special-offer-listing-card__date">${data.meta["offer_expiration-date"]}</p>
        </div>
      `;
    }
  }

  events(data) {
    return `
      <div class="events-listing-card">
          <a href="` + data.link + `" class="events-listing-card__link">
              <picture class="events-listing-card__image-container">
                  <img class="events-listing-card__image" src="` + this.getFeaturedImageUrl(data.featured_image_url) + `" alt="` + data.title + `" />
              </picture>
              <h3 class="events-listing-card__title">` + data.post_title + `</h3>
              <p class="events-listing-card__date">` + data.frontend_date + `</p>
          </a>
      </div>
    `;
  }
}
